/**
 * OFC Royalties
 *
 * Bonus points for strong hands:
 * - Front: pairs 66+, trips
 * - Middle: trips+ (2x back values for standard, lowball for 2-7)
 * - Back: straight+
 */
import { Label, Rank } from './enums';
import { RoyaltyTable } from './types';

// ============================================================================
// Shared Royalty Data
// ============================================================================

const FRONT_ROYALTIES = new Map<string, number>([
  ['66', 1],
  ['77', 2],
  ['88', 3],
  ['99', 4],
  ['TT', 5],
  ['JJ', 6],
  ['QQ', 7],
  ['KK', 8],
  ['AA', 9],
  ['222', 10],
  ['333', 11],
  ['444', 12],
  ['555', 13],
  ['666', 14],
  ['777', 15],
  ['888', 16],
  ['999', 17],
  ['TTT', 18],
  ['JJJ', 19],
  ['QQQ', 20],
  ['KKK', 21],
  ['AAA', 22],
]);

const BACK_ROYALTIES = new Map<Label, number>([
  [Label.STRAIGHT, 2],
  [Label.FLUSH, 4],
  [Label.FULL_HOUSE, 6],
  [Label.FOUR_OF_A_KIND, 10],
  [Label.STRAIGHT_FLUSH, 15],
  [Label.ROYAL_FLUSH, 25],
]);

const MIDDLE_ROYALTIES = new Map<Label, number>([
  [Label.THREE_OF_A_KIND, 2],
  [Label.STRAIGHT, 4],
  [Label.FLUSH, 8],
  [Label.FULL_HOUSE, 12],
  [Label.FOUR_OF_A_KIND, 20],
  [Label.STRAIGHT_FLUSH, 30],
  [Label.ROYAL_FLUSH, 50],
]);

// ============================================================================
// Royalty Tables
// ============================================================================

export const STANDARD_ROYALTIES: RoyaltyTable = {
  front: FRONT_ROYALTIES,
  middle: MIDDLE_ROYALTIES,
  back: BACK_ROYALTIES,
};

export const DEUCE_TO_SEVEN_ROYALTIES: RoyaltyTable = {
  front: FRONT_ROYALTIES,
  middle: new Map(), // 2-7 uses lowball scoring for middle
  back: BACK_ROYALTIES,
};

/**
 * 2-7 middle row lowball royalties (by high card rank)
 * Perfect 7-high = 4, 8-high = 2, 9-high = 1
 */
export const DEUCE_TO_SEVEN_MIDDLE_ROYALTIES = new Map<Rank, number>([
  [Rank.NINE, 1],
  [Rank.EIGHT, 2],
  [Rank.SEVEN, 4],
]);

// ============================================================================
// Scoring Constants
// ============================================================================

export const SCOOP_BONUS = 3;
export const FOUL_PENALTY = -6;
